import { ChoiceRadio, ChoiceRadioItem } from '@ingka/choice';
import Skeleton from '@ingka/skeleton';
import { formatDateWithWeekday, formatTime } from '@repo/utils';

import {
    type TimeWindowAffectedServiceUpdateItem,
    TimeWindowListItemContent,
} from './time-window-list-item-content.component';

import styles from './styles.module.scss';

export interface TimeWindowListItem {
    affectedServiceUpdateItems: TimeWindowAffectedServiceUpdateItem[];
    errorCode?: string | undefined;
    fromDateTimeUtc: string;
    id: string;
    isLoading: boolean;
    priceLabel?: string | undefined;
    toDateTimeUtc: string;
    tspName?: string | undefined;
    timeZone: string;
}

interface Props {
    items: TimeWindowListItem[];
    selectedDate: Date;
    selectedTimeWindowId?: string | undefined;
    dateFormat: string;
    timeFormat: string;
    onTimeWindowSelect: (timeWindowId: string) => void;
    timeZone?: string | undefined;
}

export const TimeWindowsList = ({
    items,
    selectedDate,
    selectedTimeWindowId,
    dateFormat,
    timeFormat,
    onTimeWindowSelect,
    timeZone,
}: Props) => {
    const selectedDateString = formatDateWithWeekday(selectedDate.toISOString(), dateFormat, timeZone);
    const displayDate = selectedDateString.charAt(0).toUpperCase() + selectedDateString.slice(1);

    return (
        <div className={styles.container}>
            <ChoiceRadio className={String(styles.time_windows_list)} legend={displayDate} size="medium">
                {items.map((item) => (
                    <ChoiceRadioItem
                        key={item.id}
                        id={`time-window-${item.id}`}
                        disabled={item.isLoading}
                        name="time-window"
                        customContent={
                            <TimeWindowListItemContent
                                timeLabel={`${formatTime(item.fromDateTimeUtc, timeFormat, item.timeZone)} - ${formatTime(item.toDateTimeUtc, timeFormat, item.timeZone)}`}
                                priceLabel={
                                    item.isLoading ? (
                                        <Skeleton width="5rem" />
                                    ) : (
                                        (item.priceLabel ?? <Skeleton width="5rem" />)
                                    )
                                }
                                tspName={item.tspName}
                                affectedServiceUpdateItems={item.affectedServiceUpdateItems}
                                errorCode={item.errorCode}
                            />
                        }
                        onChange={() => {
                            onTimeWindowSelect(item.id);
                        }}
                        value={item.id}
                        checked={selectedTimeWindowId === item.id}
                    />
                ))}
            </ChoiceRadio>
        </div>
    );
};
